import { ceilMeasure } from "../constants";

export const getHeightFromDate = (start: Date, end: Date) =>
((((end.getHours() - start.getHours()) * 60)
  - start.getMinutes() + end.getMinutes()) / ceilMeasure);

export const getTopFromDate = (date: Date, startHour: number) =>
  (((date.getMinutes() + date.getHours() * 60) - (startHour * 60)) / ceilMeasure);
